document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.wpcf7-form').forEach(form => {
    const phoneInput = form.querySelector('input[name="phone"]');
    const nameInput = form.querySelector('input[name="full-name"]');
    const emailInput = form.querySelector('input[name="email"]');
    const stateInput = form.querySelector('select[name="state"]');
    const cityInput = form.querySelector('input[name="city"]');
    const submitBtn = form.querySelector('.cf7-submit-button');

    function validateForm() {
      const nameValid = nameInput && nameInput.value.trim().length > 0;
      const phoneValid = phoneInput && phoneInput.value.trim().length > 0;
      const emailValid = emailInput && emailInput.value.trim().length > 0;
      const stateValid = stateInput && stateInput.value.trim().length > 0 && stateInput.value !== "";
      const cityValid = cityInput && cityInput.value.trim().length > 1; // Require at least 2 chars for city name

      if (nameValid && phoneValid && emailValid && stateValid && cityValid) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-disabled');
        }
      } else {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('is-disabled');
        }
      }
    }

    if (phoneInput) {
      function formatPhone(value) {
        let digits = value.replace(/\D/g, "");
        // Si tiene más de 10 dígitos y empieza con 1, quita el primer 1
        if (digits.length > 10 && digits.startsWith("1")) {
          digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);

        let formatted = "";
        if (digits.length > 0) formatted += "(" + digits.substring(0, 3);
        if (digits.length >= 4) formatted += ") " + digits.substring(3, 6);
        if (digits.length >= 7) formatted += "-" + digits.substring(6, 10);

        return formatted;
      }

      phoneInput.addEventListener("input", (e) => {
        e.target.value = formatPhone(e.target.value);
        validateForm();
      });

      // Corrige autofill al cargar la página
      setTimeout(() => {
        phoneInput.value = formatPhone(phoneInput.value);
        validateForm();
      }, 100);
    }

    [nameInput, emailInput, stateInput, cityInput].forEach(input => {
      if (input) input.addEventListener('input', validateForm);
      if (input && input.tagName === 'SELECT') input.addEventListener('change', validateForm);
    });

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-disabled');
    }
  });
});
